const ACCOUNT_SELECTION_STORAGE_KEY_PREFIX = "selectedAccount";

const getStorageKey = (userId?: string) => {
  if (!userId) return undefined;
  return `${ACCOUNT_SELECTION_STORAGE_KEY_PREFIX}:${userId}`;
};

export const getPersistedSelectedAccountId = (userId?: string) => {
  if (typeof window === "undefined") return undefined;

  const key = getStorageKey(userId);
  if (!key) return undefined;

  return window.localStorage.getItem(key) || undefined;
};

export const persistSelectedAccountId = (
  userId: string | undefined,
  accountId: string | undefined
) => {
  if (typeof window === "undefined") return;

  const key = getStorageKey(userId);
  if (!key) return;

  if (!accountId) {
    window.localStorage.removeItem(key);
    return;
  }

  window.localStorage.setItem(key, accountId);
};

export const clearPersistedSelectedAccountIds = () => {
  if (typeof window === "undefined") return;

  const keysToDelete: string[] = [];
  for (let index = 0; index < window.localStorage.length; index += 1) {
    const key = window.localStorage.key(index);
    if (key && key.startsWith(`${ACCOUNT_SELECTION_STORAGE_KEY_PREFIX}:`)) {
      keysToDelete.push(key);
    }
  }

  keysToDelete.forEach((key) => window.localStorage.removeItem(key));
};
